export default "__VITE_ASSET__Cmuh1Aci__"